// Google Analytics 4 (gtag). Measurement ID comes from REACT_APP_GA4_ID; nothing is loaded without it.
// In preview/localhost the real tag is never loaded: calls are recorded in window.__gaCalls for tests.
export const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const PURCHASE_KEY = "mc_ga_purchase_";

const isProdHost = () => { const h = window.location.hostname; return !(h === "localhost" || h === "127.0.0.1" || h.endsWith(".preview.emergentagent.com")); };
export const gaMode = () => (!GA4_ID ? "disabled" : isProdHost() ? "live" : "stub");

export const utmContext = () => { const p = new URLSearchParams(window.location.search); const o = {}; ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => { if (p.get(k)) o[k] = p.get(k); }); return o; };

export function initGA() {
  if (typeof window === "undefined" || window.__gaInit) return;
  window.__gaInit = true;
  window.dataLayer = window.dataLayer || [];
  if (gaMode() !== "live") {
    window.__gaCalls = [];
    window.gtag = function () { window.__gaCalls.push(Array.prototype.slice.call(arguments)); };
    if (GA4_ID) { window.gtag("js", new Date()); window.gtag("config", GA4_ID, { send_page_view: false }); }
    return;
  }
  const s = document.createElement("script");
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_ID)}`;
  document.head.appendChild(s);
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: false });
}

function gtag(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return false;
  try { window.gtag(...args); return true; } catch { return false; }
}

const clean = (o) => Object.fromEntries(Object.entries(o || {}).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export function gaEvent(name, params) { return gtag("event", name, clean({ ...utmContext(), ...params })); }

export function gaPageView(pathname) {
  if (window.__gaLastPath === pathname) return;
  window.__gaLastPath = pathname;
  gaEvent("page_view", { page_path: pathname, page_location: window.location.href, page_title: document.title });
}

const ITEM = { item_id: "MYCHRISTMAS2026", item_name: "My Christmas", quantity: 1 };

export function gaBeginCheckout({ value, currency, market, language, source, provider }) {
  gaEvent("begin_checkout", { value: value != null ? Number(value) : undefined, currency, market, country: market, language, source, provider, items: [{ ...ITEM, price: value != null ? Number(value) : undefined }] });
}

// Once per transaction per browser (same rule as the Meta Pixel).
export function gaPurchase(purchase, extra = {}) {
  if (!purchase?.ref) return false;
  const key = PURCHASE_KEY + purchase.ref;
  try { if (localStorage.getItem(key)) return false; } catch { /* storage unavailable */ }
  const sent = gaEvent("purchase", { transaction_id: purchase.ref, value: purchase.value != null ? Number(purchase.value) : undefined, currency: purchase.currency, ...extra, items: [{ ...ITEM, price: purchase.value != null ? Number(purchase.value) : undefined }] });
  try { localStorage.setItem(key, new Date().toISOString()); } catch { /* ignore */ }
  return sent;
}
